import * as React from 'react';

import iconUrl from './MilitaryMortgageIcon.svg';

export const MilitaryMortgageIcon = () => <img width="24" height="43" src={iconUrl} alt="" />;

MilitaryMortgageIcon.displayName = 'MilitaryMortgageIcon';
